import {SET_APP_CONTEXT} from '../constants';
import {SetAppContextAction} from '../index';
import {Action} from '@ngrx/store';
import {Service} from './Service';
import {RequestReorderPayload} from './RequestReorderPayload';
import {
  REQUEST_SERVICE_UPDATE, REQUEST_VIDEO_ADD, REQUEST_VIDEO_DELETE, REQUEST_VIDEO_REORDER,
  SET_SERVICE, VIDEO_ADD, VIDEO_DELETE, VIDEO_REORDER,
} from './constants';
import {Video} from './Video';
import {RequestVideoPayload} from './RequestVideoPayload';
import {PHOTO_DELETE, PHOTO_UPLOAD, PHOTOS_REORDER} from '../../+edit/photos/store/ui/constants';
import {PhotoActions} from '../../+edit/photos/store/ui/reducer';

export function serviceReducer(state: Service = null, action: ServiceActionTypes | SetAppContextAction | PhotoActions): Service {
  switch (action.type) {
    case SET_APP_CONTEXT:
      return action.payload.service;
    case SET_SERVICE:
      return action.payload.res;
    case PHOTO_UPLOAD:
      return {
        ...state,
        photos: [action.payload.photo, ...state.photos],
      };
    case PHOTO_DELETE: {
      const photoIndex = state.photos.findIndex(photo => photo.id === action.payload);
      const photos = [...state.photos.slice(0, photoIndex), ...state.photos.slice(photoIndex + 1)];
      return {
        ...state,
        photos,
      };
    }
    case PHOTOS_REORDER:
      return {
        ...state,
        photos: action.payload,
      };
    case VIDEO_ADD:
      return {
        ...state,
        videos: [action.payload, ...state.videos],
      };
    case VIDEO_DELETE: {
      const videoIndex = state.videos.findIndex(video => video.id === action.payload);
      const videos = [...state.videos.slice(0, videoIndex), ...state.videos.slice(videoIndex + 1)];
      return {
        ...state,
        videos,
      };
    }
    default:
      return state;
  }
}

type MediaActions = VideoDeleteAction | VideoAddAction | VideosReorderAction;

type ServiceActionTypes = SetServiceAction | MediaActions;

export class SetServiceAction implements Action {
  readonly type = SET_SERVICE;

  constructor(public payload: { res: Service, field: string }) {}
}

export class RequestServiceUpdateAction implements Action {
  readonly type = REQUEST_SERVICE_UPDATE;

  constructor(public payload: { id: number, key: string, value: any }) {}
}

export class RequestVideoAddAction implements Action {
  readonly type = REQUEST_VIDEO_ADD;

  constructor(public payload: RequestVideoPayload) {}
}

export class VideoAddAction implements Action {
  readonly type = VIDEO_ADD;

  constructor(public payload: Video) {}
}

export class RequestVideoDeleteAction implements Action {
  readonly type = REQUEST_VIDEO_DELETE;

  constructor(public payload: RequestVideoPayload) {}
}

export class VideoDeleteAction implements Action {
  readonly type = VIDEO_DELETE;

  constructor(public payload: number) {}
}

export class RequestVideosReorderAction implements Action {
  readonly type = REQUEST_VIDEO_REORDER;

  constructor(public payload: RequestReorderPayload) {}
}

export class VideosReorderAction implements Action {
  readonly type = VIDEO_REORDER;

  constructor(public payload: Video[]) {}
}

export interface MediaActionConstructor {
  new (payload: any): MediaActions;
}
